"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FbApiTask = void 0;
// a set of tasks determines the role that a FB user has on FB PAGE
var FbApiTask;
(function (FbApiTask) {
    // main tasks
    FbApiTask["MANAGE"] = "MANAGE";
    FbApiTask["CREATE_CONTENT"] = "CREATE_CONTENT";
    FbApiTask["MODERATE"] = "MODERATE";
    FbApiTask["MESSAGING"] = "MESSAGING";
    FbApiTask["ADVERTISE"] = "ADVERTISE";
    FbApiTask["ANALYZE"] = "ANALYZE";
    // other tasks
    FbApiTask["MODERATE_COMMUNITY"] = "MODERATE_COMMUNITY";
    FbApiTask["MANAGE_JOBS"] = "MANAGE_JOBS";
    FbApiTask["PAGES_MESSAGING"] = "PAGES_MESSAGING";
    FbApiTask["PAGES_MESSAGING_SUBSCRIPTIONS"] = "PAGES_MESSAGING_SUBSCRIPTIONS";
    FbApiTask["READ_PAGE_MAILBOXES"] = "READ_PAGE_MAILBOXES";
    FbApiTask["VIEW_MONETIZATION_INSIGHTS"] = "READ_PAGE_MAILBOXES";
    FbApiTask["MANAGE_LEADS"] = "MANAGE_LEADS";
    FbApiTask["PROFILE_PLUS_FULL_CONTROL"] = "PROFILE_PLUS_FULL_CONTROL";
    FbApiTask["PROFILE_PLUS_MANAGE"] = "PROFILE_PLUS_MANAGE";
    FbApiTask["PROFILE_PLUS_FACEBOOK_ACCESS"] = "PROFILE_PLUS_FACEBOOK_ACCESS";
    FbApiTask["PROFILE_PLUS_CREATE_CONTENT"] = "PROFILE_PLUS_CREATE_CONTENT";
    FbApiTask["PROFILE_PLUS_MODERATE"] = "PROFILE_PLUS_MODERATE";
    FbApiTask["PROFILE_PLUS_MESSAGING"] = "PROFILE_PLUS_MESSAGING";
    FbApiTask["PROFILE_PLUS_ADVERTISE"] = "PROFILE_PLUS_ADVERTISE";
    FbApiTask["PROFILE_PLUS_ANALYZE"] = "PROFILE_PLUS_ANALYZE";
    FbApiTask["PROFILE_PLUS_REVENUE"] = "PROFILE_PLUS_REVENUE";
    FbApiTask["CASHIER_ROLE"] = "CASHIER_ROLE";
})(FbApiTask = exports.FbApiTask || (exports.FbApiTask = {}));
//# sourceMappingURL=fbApiTask.enum.js.map